/**
 * state/useSession.js -- El puente entre sessionStore.js (plano, sin
 * React) y los componentes. `useSyncExternalStore` es el hook oficial de
 * React para esto exacto: "tengo un store externo mutable, avisame
 * cuando cambie". Cada componente que llama a useSession() se
 * re-renderiza solo cuando setSession/clearSession/patchSession
 * reemplazan la referencia -- nunca en falso.
 *
 * No hay <SessionProvider> ni Context aqui a proposito: sessionStore.js
 * ya es un singleton de modulo (exactamente como lo era state.js en el
 * original), asi que cualquier componente puede llamar useSession() sin
 * envolver nada -- mismo patron de "un solo lugar que sabe quien soy",
 * ahora con menos piezas que un Context.
 */
import { useSyncExternalStore } from 'react';
import { subscribeSession, getSession, can as canRaw } from '../lib/sessionStore.js';

export function useSession() {
  const session = useSyncExternalStore(subscribeSession, getSession);
  return {
    session,
    can: (codigo) => canRaw(codigo),
  };
}
